import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./cookieconsent.css";

const CONSENT_KEY = "wefinance_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      // Small delay so the banner doesn't flash before first paint
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-overlay" role="dialog" aria-modal="true" aria-label="Cookie consent">
      <div className="cookie-banner">
        <div className="cookie-icon" aria-hidden="true">🍪</div>
        <div className="cookie-body">
          <h5 className="cookie-title">We value your privacy</h5>
          <p className="cookie-text">
            We use cookies and similar technologies to enhance your experience,
            analyse site traffic, and personalise content. By clicking{" "}
            <strong>"I Agree"</strong>, you consent to our use of cookies and
            the processing of your personal data in accordance with our{" "}
            <Link to="/privacypolicy" className="cookie-link" onClick={handleAccept}>
              Privacy Policy
            </Link>
            .
          </p>
        </div>
        <div className="cookie-actions">
          <button className="cookie-btn cookie-btn--accept" onClick={handleAccept}>
            I Agree
          </button>
          <button className="cookie-btn cookie-btn--decline" onClick={handleDecline}>
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
